var map = {
	"./cjpublishing-orlkis-wgm/locales/index.js": [
		"n++s",
		28
	],
	"./cjpublishing-sb-wgm/locales/index.js": [
		"OO40",
		27
	],
	"./cjpublishing-stp-dd/locales/index.js": [
		"ieKo",
		26
	],
	"./cjpublishing-swfl-wgm/locales/index.js": [
		"IB3/",
		25
	],
	"./cjpublishing-tb-wgm/locales/index.js": [
		"1EWs",
		24
	],
	"./cjpublishing-tpa-dd/locales/index.js": [
		"2RDo",
		23
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "oIFL";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/assets/client lazy ^\.\/.*\/locales\/index\.js$
// module id = oIFL
// module chunks = 44